if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"fieldViewParentReferenceModule","remotes":[],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return /^(128|327|363|458|524|852|922|954)$/.test(chunkId)},
		rootOutputDir: "",
		bundlerRuntimeOptions: { remotes: { remoteInfos: {}, webpackRequire: __webpack_require__,idToRemoteMap: {}, chunkMapping: {},idToExternalAndNameMapping: {} } }
	};
__webpack_require__.consumesLoadingData = {}
__webpack_require__.remotesLoadingData = {}
}